<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'read',
    subject: 'UserGuide',
  },
})

const contohModifier = [
  {
    group: 'Level Manis',
    wajib: true,
    multiPilih: false,
    opsi: [
      { nama: 'Normal', harga: 'Rp 0' },
      { nama: 'Less Sugar', harga: 'Rp 0' },
      { nama: 'No Sugar', harga: 'Rp 0' },
    ],
    catatan: 'Pelanggan wajib pilih 1 level manis untuk setiap minuman',
  },
  {
    group: 'Level Es',
    wajib: true,
    multiPilih: false,
    opsi: [
      { nama: 'Normal Ice', harga: 'Rp 0' },
      { nama: 'Less Ice', harga: 'Rp 0' },
      { nama: 'No Ice', harga: 'Rp 0' },
    ],
    catatan: 'Wajib dipilih, tidak ada biaya tambahan',
  },
  {
    group: 'Topping',
    wajib: false,
    multiPilih: true,
    opsi: [
      { nama: 'Boba', harga: '+Rp 5.000' },
      { nama: 'Nata de Coco', harga: '+Rp 3.000' },
      { nama: 'Jelly', harga: '+Rp 3.000' },
      { nama: 'Cheese Cream', harga: '+Rp 8.000' },
    ],
    catatan: 'Boleh pilih lebih dari satu, ada biaya tambahan',
  },
  {
    group: 'Suhu',
    wajib: true,
    multiPilih: false,
    opsi: [
      { nama: 'Hot', harga: 'Rp 0' },
      { nama: 'Iced', harga: 'Rp 0' },
    ],
    catatan: 'Wajib pilih panas atau dingin',
  },
  {
    group: 'Extra Shot',
    wajib: false,
    multiPilih: false,
    opsi: [
      { nama: 'Extra Espresso', harga: '+Rp 7.000' },
    ],
    catatan: 'Opsional, ada biaya tambahan',
  },
]

const fieldsGroup = [
  {
    field: 'Nama Group',
    wajib: true,
    penjelasan: 'Nama kategori pilihan tambahan. Nama ini muncul di kasir sebagai judul pilihan yang harus dipilih pelanggan.',
    contoh: '"Level Manis", "Topping", "Ukuran", "Suhu", "Extra Shot"',
  },
  {
    field: 'Wajib Dipilih',
    wajib: false,
    penjelasan: 'Jika diaktifkan (ON), kasir tidak bisa proses order tanpa memilih salah satu opsi dari group ini. Jika dimatikan (OFF), opsi bersifat opsional.',
    contoh: 'ON untuk "Level Manis" (semua pelanggan harus pilih). OFF untuk "Topping" (opsional).',
  },
  {
    field: 'Bisa Multi-pilih',
    wajib: false,
    penjelasan: 'Jika diaktifkan (ON), pelanggan boleh memilih lebih dari satu opsi dari group yang sama. Cocok untuk topping.',
    contoh: 'ON untuk "Topping" (boleh pilih Boba + Jelly sekaligus). OFF untuk "Suhu" (hanya boleh pilih Hot atau Iced, tidak keduanya).',
  },
  {
    field: 'Status Aktif',
    wajib: false,
    penjelasan: 'Group aktif = muncul di kasir saat kasir memilih produk yang terhubung. Group non-aktif = tersembunyi dari kasir.',
    contoh: 'Aktifkan semua group yang sedang berlaku. Nonaktifkan group musiman yang sedang tidak berlaku.',
  },
]

const fieldsOpsi = [
  {
    field: 'Nama Opsi',
    wajib: true,
    penjelasan: 'Nama pilihan spesifik yang muncul di kasir dan struk. Usahakan singkat dan jelas.',
    contoh: '"Normal", "Less Sugar", "No Sugar", "Boba", "Cheese Cream"',
  },
  {
    field: 'Penyesuaian Harga',
    wajib: false,
    penjelasan: 'Biaya tambahan (positif) atau diskon (negatif) saat opsi ini dipilih. Nilai 0 artinya gratis. Biaya ini ditambahkan ke harga dasar varian produk.',
    contoh: '0 untuk gratis. 5000 untuk tambah Rp 5.000. -2000 untuk kurangi Rp 2.000 (diskon).',
  },
  {
    field: 'Status Aktif',
    wajib: false,
    penjelasan: 'Opsi aktif = bisa dipilih di kasir. Nonaktifkan opsi yang sedang tidak tersedia (misalnya bahan topping habis) tanpa harus hapus.',
    contoh: 'Nonaktifkan "Boba" jika stok boba sedang habis.',
  },
]

const faq = [
  {
    q: 'Apa bedanya Modifier Group dengan Varian Produk?',
    a: 'Varian produk menentukan ukuran/jenis dasar dengan harga berbeda — misalnya "Regular Rp 20.000" vs "Large Rp 25.000". Modifier Group adalah pilihan tambahan di atas varian — misalnya setelah pelanggan pilih "Regular", kasir akan tanya "Level manisnya?" dan "Tambah topping?". Varian = produk berbeda, Modifier = kustomisasi produk yang sama.',
  },
  {
    q: 'Apakah Modifier Group harus terhubung ke produk tertentu?',
    a: 'Di PintuKasir, Modifier Group bersifat global — artinya semua group yang sudah dibuat bisa diterapkan ke produk manapun. Penghubungan antara group dan produk dilakukan dari halaman edit produk, bukan dari halaman Modifier Group. Buat group dulu, lalu hubungkan ke produk yang relevan.',
  },
  {
    q: 'Bisakah satu group Modifier dipakai untuk banyak produk?',
    a: 'Ya! Itulah keuntungan utama Modifier Group. Anda cukup buat satu group "Level Manis" sekali, lalu hubungkan ke semua produk minuman yang membutuhkan pilihan level manis. Tidak perlu buat ulang untuk setiap produk.',
  },
  {
    q: 'Bagaimana jika topping tertentu sedang habis?',
    a: 'Nonaktifkan opsi topping tersebut saja — jangan dihapus. Caranya: buka Edit Modifier Group, temukan opsi yang dimaksud, matikan toggle "Aktif"-nya, lalu simpan. Opsi tersebut langsung menghilang dari kasir. Saat stok sudah ada lagi, aktifkan kembali.',
  },
  {
    q: 'Apakah penyesuaian harga modifier bisa minus (negatif)?',
    a: 'Ya, bisa. Misalnya Anda punya opsi "No Sugar" yang memberikan diskon Rp 2.000, isi field "Penyesuaian Harga" dengan -2000. Harga akhir akan otomatis dikurangi Rp 2.000 dari harga dasar varian. Ini berguna untuk promo atau opsi yang lebih hemat.',
  },
  {
    q: 'Berapa batas jumlah opsi dalam satu Modifier Group?',
    a: 'Tidak ada batas jumlah opsi dalam satu group. Namun untuk kenyamanan kasir, disarankan tidak lebih dari 8–10 opsi per group agar tidak perlu scroll terlalu banyak saat di kasir.',
  },
  {
    q: 'Jika Modifier Group dihapus, apakah mempengaruhi data transaksi lama?',
    a: 'Tidak. Data transaksi yang sudah tercatat tetap aman. Modifier yang terpilih di transaksi lama tetap tersimpan di database dan muncul di struk/laporan lama. Hanya saja group tersebut tidak bisa dipilih lagi untuk transaksi baru.',
  },
]
</script>

<template>
  <div>
    <!-- Breadcrumb -->
    <VRow>
      <VCol cols="12">
        <div class="d-flex align-center gap-2 mb-2">
          <RouterLink
            to="/userguide"
            class="text-decoration-none text-medium-emphasis text-body-2"
          >
            User Guide
          </RouterLink>
          <VIcon icon="ri-arrow-right-s-line" size="16" class="text-medium-emphasis" />
          <span class="text-body-2">Produk &amp; Inventory</span>
          <VIcon icon="ri-arrow-right-s-line" size="16" class="text-medium-emphasis" />
          <span class="text-body-2">Modifier Groups</span>
        </div>
      </VCol>
    </VRow>

    <!-- Header -->
    <VRow>
      <VCol cols="12">
        <div class="d-flex align-center mb-4 flex-wrap gap-3">
          <VAvatar color="warning" variant="tonal" size="64" rounded="lg">
            <VIcon icon="ri-checkbox-multiple-line" size="36" />
          </VAvatar>
          <div>
            <h4 class="text-h4 font-weight-bold mb-0">Modifier Groups</h4>
            <p class="text-body-2 text-medium-emphasis mb-0">
              Kelola pilihan tambahan produk: topping, level manis, suhu, ukuran, dan lainnya
            </p>
          </div>
        </div>

        <VAlert type="info" variant="tonal" icon="ri-flag-line" class="mb-0">
          <strong>Tujuan halaman ini:</strong>
          Memandu Anda membuat dan mengatur pilihan tambahan (modifier) yang bisa dipilih
          pelanggan saat memesan. Contoh: "Mau level manisnya normal atau less sugar?",
          "Mau tambah topping boba?"
        </VAlert>
      </VCol>
    </VRow>

    <!-- ── KONSEP ──────────────────────────────────────────────────────── -->
    <VRow class="mt-6">
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-book-open-line" class="me-2" color="warning" />
            Apa itu Modifier Group?
          </VCardTitle>
          <VCardText>
            <p class="text-body-2 mb-3">
              Modifier Group adalah <strong>kumpulan pilihan kustomisasi</strong> yang bisa
              ditawarkan kasir kepada pelanggan saat mereka memesan produk.
            </p>

            <p class="text-body-2 mb-4">
              Bayangkan Anda pergi ke coffee shop dan barista bertanya:
              <em>"Mau hot atau iced?"</em>, <em>"Level manisnya?"</em>, dan
              <em>"Mau tambah topping?"</em> — setiap pertanyaan itu adalah sebuah <strong>Modifier Group</strong>.
              Setiap jawaban yang tersedia (Normal, Less Sugar, No Sugar) adalah sebuah <strong>Opsi</strong>.
            </p>

            <VAlert type="success" variant="tonal" class="mb-4">
              <p class="text-body-2 font-weight-bold mb-2">
                Contoh penggunaan di coffee shop:
              </p>
              <p class="text-body-2 mb-0">
                Pelanggan pesan <strong>1 Matcha Latte</strong>. Kasir akan ditanya:
              </p>
              <ol class="text-body-2 ps-4 mb-0">
                <li>Suhu: <strong>Iced</strong> ← dari group "Suhu" (wajib)</li>
                <li>Level Manis: <strong>Less Sugar</strong> ← dari group "Level Manis" (wajib)</li>
                <li>Topping: <strong>Boba (+Rp 5.000)</strong> ← dari group "Topping" (opsional)</li>
              </ol>
              <p class="text-body-2 mt-2 mb-0">
                Total: Rp 25.000 (Matcha) + Rp 5.000 (Boba) = <strong>Rp 30.000</strong>
              </p>
            </VAlert>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- ── CONTOH MODIFIER GROUP ──────────────────────────────────────── -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-list-check-2" class="me-2" color="info" />
            Contoh Modifier Group untuk Coffee Shop
          </VCardTitle>
          <VCardText>
            <p class="text-body-2 mb-4">
              Berikut adalah contoh-contoh Modifier Group yang umum digunakan oleh coffee shop.
              Anda bisa membuat group yang sesuai dengan kebutuhan toko Anda sendiri.
            </p>

            <VExpansionPanels variant="accordion">
              <VExpansionPanel v-for="item in contohModifier" :key="item.group">
                <VExpansionPanelTitle>
                  <div class="d-flex align-center gap-3 flex-wrap">
                    <span class="text-body-2 font-weight-bold">{{ item.group }}</span>
                    <VChip
                      :color="item.wajib ? 'error' : 'default'"
                      size="x-small"
                      variant="tonal"
                    >
                      {{ item.wajib ? 'Wajib dipilih' : 'Opsional' }}
                    </VChip>
                    <VChip
                      :color="item.multiPilih ? 'info' : 'default'"
                      size="x-small"
                      variant="tonal"
                    >
                      {{ item.multiPilih ? 'Multi-pilih' : 'Pilih 1' }}
                    </VChip>
                  </div>
                </VExpansionPanelTitle>
                <VExpansionPanelText>
                  <p class="text-caption text-medium-emphasis mb-3">
                    {{ item.catatan }}
                  </p>
                  <VTable density="compact">
                    <thead>
                      <tr>
                        <th>Nama Opsi</th>
                        <th>Biaya Tambahan</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="opsi in item.opsi" :key="opsi.nama">
                        <td class="text-body-2">
                          {{ opsi.nama }}
                        </td>
                        <td>
                          <VChip
                            :color="opsi.harga === 'Rp 0' ? 'default' : 'success'"
                            size="x-small"
                            variant="tonal"
                          >
                            {{ opsi.harga }}
                          </VChip>
                        </td>
                      </tr>
                    </tbody>
                  </VTable>
                </VExpansionPanelText>
              </VExpansionPanel>
            </VExpansionPanels>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- ── CARA MEMBUAT MODIFIER GROUP ───────────────────────────────── -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-add-circle-line" class="me-2" color="success" />
            Cara Membuat Modifier Group Baru
          </VCardTitle>
          <VCardText>
            <p class="text-body-2 mb-4">
              Proses membuat Modifier Group terdiri dari dua bagian:
              mengatur informasi group, lalu menambahkan opsi-opsi di dalamnya.
            </p>

            <VTimeline side="end" density="compact" truncate-line="both">
              <VTimelineItem dot-color="primary" size="small">
                <template #opposite>
                  <span class="text-caption font-weight-bold text-primary">Langkah 1</span>
                </template>
                <p class="text-body-2 mb-0">
                  Buka menu <strong>Katalog → Modifier Groups</strong> dari sidebar kiri.
                  Anda akan melihat daftar semua Modifier Group yang sudah ada.
                </p>
              </VTimelineItem>

              <VTimelineItem dot-color="primary" size="small">
                <template #opposite>
                  <span class="text-caption font-weight-bold text-primary">Langkah 2</span>
                </template>
                <p class="text-body-2 mb-0">
                  Klik tombol <strong>"+ Tambah Group"</strong> di pojok kanan atas.
                </p>
              </VTimelineItem>

              <VTimelineItem dot-color="info" size="small">
                <template #opposite>
                  <span class="text-caption font-weight-bold text-info">Langkah 3</span>
                </template>
                <div>
                  <p class="text-body-2 mb-2">
                    Isi <strong>Informasi Group</strong>:
                  </p>
                  <ul class="text-body-2 ps-4">
                    <li class="mb-1">
                      <strong>Nama Group</strong> — contoh: "Level Manis" atau "Topping"
                    </li>
                    <li class="mb-1">
                      <strong>Wajib Dipilih</strong> — aktifkan jika kasir wajib memilihkan ini untuk pelanggan
                    </li>
                    <li>
                      <strong>Bisa Multi-pilih</strong> — aktifkan jika pelanggan boleh pilih lebih dari satu opsi
                    </li>
                  </ul>
                </div>
              </VTimelineItem>

              <VTimelineItem dot-color="info" size="small">
                <template #opposite>
                  <span class="text-caption font-weight-bold text-info">Langkah 4</span>
                </template>
                <div>
                  <p class="text-body-2 mb-2">
                    Tambahkan <strong>Daftar Opsi</strong>. Sistem sudah menyiapkan 1 baris opsi kosong:
                  </p>
                  <ul class="text-body-2 ps-4">
                    <li class="mb-1">
                      Isi <strong>Nama Opsi</strong> — contoh: "Normal", "Less Sugar", "No Sugar"
                    </li>
                    <li class="mb-1">
                      Isi <strong>Penyesuaian Harga</strong> — isi 0 jika gratis, isi 5000 jika tambah Rp 5.000
                    </li>
                    <li class="mb-1">
                      Klik <strong>"+ Tambah Opsi"</strong> untuk menambah baris opsi berikutnya
                    </li>
                    <li>
                      Klik ikon <strong>tempat sampah</strong> untuk hapus opsi yang tidak diperlukan
                    </li>
                  </ul>
                </div>
              </VTimelineItem>

              <VTimelineItem dot-color="warning" size="small">
                <template #opposite>
                  <span class="text-caption font-weight-bold text-warning">Langkah 5</span>
                </template>
                <p class="text-body-2 mb-0">
                  Di sisi kanan, pastikan toggle <strong>"Group Aktif"</strong> dalam posisi menyala (hijau).
                  Group non-aktif tidak akan muncul di kasir.
                </p>
              </VTimelineItem>

              <VTimelineItem dot-color="success" size="small">
                <template #opposite>
                  <span class="text-caption font-weight-bold text-success">Langkah 6</span>
                </template>
                <p class="text-body-2 mb-0">
                  Klik <strong>"Simpan Group"</strong>. Modifier Group siap digunakan! ✅
                  <br>
                  <span class="text-caption text-medium-emphasis">
                    Langkah berikutnya: hubungkan group ini ke produk yang relevan dari halaman Edit Produk.
                  </span>
                </p>
              </VTimelineItem>
            </VTimeline>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- ── PENJELASAN FIELD ───────────────────────────────────────────── -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-list-check-2" class="me-2" color="warning" />
            Penjelasan Detail Setiap Field
          </VCardTitle>
          <VCardText>
            <h6 class="text-h6 font-weight-bold mb-3">
              A. Informasi Group
            </h6>
            <VTable class="mb-6">
              <thead>
                <tr>
                  <th style="min-width: 140px">
                    Field
                  </th>
                  <th style="min-width: 80px">
                    Wajib?
                  </th>
                  <th>Penjelasan</th>
                  <th style="min-width: 180px">
                    Contoh
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="f in fieldsGroup" :key="f.field">
                  <td>
                    <strong>{{ f.field }}</strong>
                  </td>
                  <td>
                    <VChip
                      :color="f.wajib ? 'error' : 'default'"
                      size="x-small"
                      variant="tonal"
                    >
                      {{ f.wajib ? '✅ Wajib' : '❌ Opsional' }}
                    </VChip>
                  </td>
                  <td class="text-body-2 py-2">
                    {{ f.penjelasan }}
                  </td>
                  <td class="text-body-2 py-2 text-medium-emphasis">
                    {{ f.contoh }}
                  </td>
                </tr>
              </tbody>
            </VTable>

            <h6 class="text-h6 font-weight-bold mb-3">
              B. Daftar Opsi (Modifier)
            </h6>
            <VTable>
              <thead>
                <tr>
                  <th style="min-width: 160px">
                    Field
                  </th>
                  <th style="min-width: 80px">
                    Wajib?
                  </th>
                  <th>Penjelasan</th>
                  <th style="min-width: 200px">
                    Contoh
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="f in fieldsOpsi" :key="f.field">
                  <td>
                    <strong>{{ f.field }}</strong>
                  </td>
                  <td>
                    <VChip
                      :color="f.wajib ? 'error' : 'default'"
                      size="x-small"
                      variant="tonal"
                    >
                      {{ f.wajib ? '✅ Wajib' : '❌ Opsional' }}
                    </VChip>
                  </td>
                  <td class="text-body-2 py-2">
                    {{ f.penjelasan }}
                  </td>
                  <td class="text-body-2 py-2 text-medium-emphasis">
                    {{ f.contoh }}
                  </td>
                </tr>
              </tbody>
            </VTable>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- ── EDIT MODIFIER GROUP ────────────────────────────────────────── -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-edit-line" class="me-2" color="info" />
            Cara Mengedit Modifier Group
          </VCardTitle>
          <VCardText>
            <p class="text-body-2 mb-4">
              Halaman edit Modifier Group memiliki <strong>2 cara simpan</strong>
              yang bisa Anda gunakan sesuai kebutuhan.
            </p>

            <VRow class="mb-4">
              <VCol cols="12" md="6">
                <VCard variant="outlined" color="primary">
                  <VCardTitle class="pa-3 pb-1 text-body-1">
                    <VIcon icon="ri-save-line" size="18" class="me-1" />
                    Tombol "Simpan Semua"
                  </VCardTitle>
                  <VCardText class="text-body-2">
                    Menyimpan semua perubahan sekaligus — termasuk nama group, pengaturan wajib/multi-pilih,
                    dan semua opsi yang ada. Gunakan ini jika Anda melakukan banyak perubahan
                    sekaligus. Klik di pojok kanan bawah.
                  </VCardText>
                </VCard>
              </VCol>
              <VCol cols="12" md="6">
                <VCard variant="outlined" color="warning">
                  <VCardTitle class="pa-3 pb-1 text-body-1">
                    <VIcon icon="ri-save-2-line" size="18" class="me-1" />
                    Ikon Simpan Per Opsi (🖫)
                  </VCardTitle>
                  <VCardText class="text-body-2">
                    Setiap baris opsi yang sudah tersimpan memiliki ikon simpan kecil (🖫) di sebelah kanan.
                    Klik ikon ini untuk update <strong>satu opsi saja</strong> tanpa mempengaruhi opsi lain.
                    Berguna jika Anda hanya ubah harga topping tertentu saja.
                  </VCardText>
                </VCard>
              </VCol>
            </VRow>

            <ol class="text-body-2 ps-4">
              <li class="mb-2">
                Di daftar Modifier Groups, klik ikon <strong>pensil (✏️)</strong> di baris group yang ingin diubah
              </li>
              <li class="mb-2">
                Lakukan perubahan yang diinginkan
              </li>
              <li class="mb-2">
                Pilih cara simpan: klik <strong>"Simpan Semua"</strong> atau klik ikon <strong>simpan per opsi (🖫)</strong>
              </li>
            </ol>

            <VAlert type="info" variant="tonal" class="mt-3" density="compact">
              <strong>Info:</strong> Opsi yang baru ditambahkan (belum punya ID) hanya bisa disimpan
              dengan tombol <strong>"Simpan Semua"</strong>. Ikon simpan per-opsi hanya muncul
              untuk opsi yang sudah pernah tersimpan sebelumnya.
            </VAlert>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- ── SKENARIO UMUM ──────────────────────────────────────────────── -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard>
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-tools-line" class="me-2" color="secondary" />
            Skenario Umum &amp; Cara Menanganinya
          </VCardTitle>
          <VCardText>
            <VRow>
              <VCol cols="12" md="6">
                <div class="d-flex align-start gap-3 mb-5">
                  <VAvatar color="warning" variant="tonal" size="36" rounded class="mt-1 flex-shrink-0">
                    <span class="text-body-2 font-weight-bold">1</span>
                  </VAvatar>
                  <div>
                    <p class="text-body-2 font-weight-bold mb-1">
                      Stok topping habis sementara
                    </p>
                    <p class="text-body-2 text-medium-emphasis mb-0">
                      Edit group Topping → matikan toggle Aktif pada opsi topping yang habis.
                      Opsi otomatis hilang dari kasir. Aktifkan kembali saat stok ada.
                    </p>
                  </div>
                </div>
              </VCol>
              <VCol cols="12" md="6">
                <div class="d-flex align-start gap-3 mb-5">
                  <VAvatar color="info" variant="tonal" size="36" rounded class="mt-1 flex-shrink-0">
                    <span class="text-body-2 font-weight-bold">2</span>
                  </VAvatar>
                  <div>
                    <p class="text-body-2 font-weight-bold mb-1">
                      Ingin naikkan harga topping
                    </p>
                    <p class="text-body-2 text-medium-emphasis mb-0">
                      Edit group → ubah angka "Penyesuaian Harga" di baris topping yang dimaksud
                      → klik ikon simpan (🖫) di baris tersebut. Selesai tanpa ubah opsi lain.
                    </p>
                  </div>
                </div>
              </VCol>
              <VCol cols="12" md="6">
                <div class="d-flex align-start gap-3 mb-5">
                  <VAvatar color="success" variant="tonal" size="36" rounded class="mt-1 flex-shrink-0">
                    <span class="text-body-2 font-weight-bold">3</span>
                  </VAvatar>
                  <div>
                    <p class="text-body-2 font-weight-bold mb-1">
                      Ingin tambah varian topping baru
                    </p>
                    <p class="text-body-2 text-medium-emphasis mb-0">
                      Edit group → klik "+ Tambah Opsi" → isi nama dan harga opsi baru
                      → klik "Simpan Semua". Opsi langsung tersedia di kasir.
                    </p>
                  </div>
                </div>
              </VCol>
              <VCol cols="12" md="6">
                <div class="d-flex align-start gap-3 mb-5">
                  <VAvatar color="error" variant="tonal" size="36" rounded class="mt-1 flex-shrink-0">
                    <span class="text-body-2 font-weight-bold">4</span>
                  </VAvatar>
                  <div>
                    <p class="text-body-2 font-weight-bold mb-1">
                      Modifier Group tidak muncul di kasir
                    </p>
                    <p class="text-body-2 text-medium-emphasis mb-0">
                      Periksa: (1) apakah toggle "Group Aktif" menyala? (2) apakah group sudah
                      dihubungkan ke produk di halaman Edit Produk? Keduanya harus terpenuhi
                      agar group muncul di kasir.
                    </p>
                  </div>
                </div>
              </VCol>
            </VRow>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- ── PERINGATAN ─────────────────────────────────────────────────── -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard color="error" variant="tonal">
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-error-warning-line" class="me-2" />
            ⚠️ Hal Penting yang Perlu Diperhatikan
          </VCardTitle>
          <VCardText>
            <VList density="compact" class="bg-transparent">
              <VListItem prepend-icon="ri-close-circle-line" class="px-0">
                <VListItemTitle class="text-body-2 text-wrap">
                  <strong>Modifier Group yang dihapus tidak bisa dikembalikan.</strong>
                  Sebaiknya nonaktifkan group (matikan toggle "Group Aktif") daripada menghapus
                  jika Anda masih mungkin membutuhkannya di masa depan.
                </VListItemTitle>
              </VListItem>
              <VListItem prepend-icon="ri-close-circle-line" class="px-0">
                <VListItemTitle class="text-body-2 text-wrap">
                  <strong>Perubahan harga opsi berlaku langsung untuk transaksi berikutnya.</strong>
                  Transaksi yang sudah terjadi tidak terpengaruh. Selalu periksa harga sebelum
                  simpan agar tidak ada kesalahan di kasir.
                </VListItemTitle>
              </VListItem>
              <VListItem prepend-icon="ri-close-circle-line" class="px-0">
                <VListItemTitle class="text-body-2 text-wrap">
                  <strong>"Simpan Semua" akan me-replace seluruh daftar opsi.</strong>
                  Jika ada opsi yang tidak sengaja dihapus dari daftar sebelum klik "Simpan Semua",
                  opsi tersebut akan ikut terhapus. Periksa kembali daftar opsi sebelum simpan.
                </VListItemTitle>
              </VListItem>
            </VList>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- ── TIPS ───────────────────────────────────────────────────────── -->
    <VRow class="mt-4">
      <VCol cols="12">
        <VCard color="success" variant="tonal">
          <VCardTitle class="pa-4 pb-2">
            <VIcon icon="ri-lightbulb-line" class="me-2" />
            💡 Tips &amp; Praktik Terbaik
          </VCardTitle>
          <VCardText>
            <VList density="compact" class="bg-transparent">
              <VListItem prepend-icon="ri-star-line" class="px-0">
                <VListItemTitle class="text-body-2 text-wrap">
                  <strong>Buat group sebelum input produk.</strong>
                  Modifier Group dan Produk bisa dibuat dalam urutan apa saja,
                  tapi lebih mudah jika Anda selesaikan semua group dulu,
                  baru hubungkan ke produk satu per satu.
                </VListItemTitle>
              </VListItem>
              <VListItem prepend-icon="ri-star-line" class="px-0">
                <VListItemTitle class="text-body-2 text-wrap">
                  <strong>Pisahkan group "Wajib" dan "Opsional" dengan jelas.</strong>
                  Group seperti "Suhu" atau "Level Manis" biasanya wajib dipilih.
                  Group seperti "Topping Extra" biasanya opsional.
                  Pengaturan yang tepat mempercepat alur kasir dan mengurangi lupa tanya ke pelanggan.
                </VListItemTitle>
              </VListItem>
              <VListItem prepend-icon="ri-star-line" class="px-0">
                <VListItemTitle class="text-body-2 text-wrap">
                  <strong>Gunakan penyesuaian harga negatif untuk promosi bundling.</strong>
                  Misalnya opsi "Ambil 2 Topping Sekaligus" dengan harga -2000 (diskon Rp 2.000).
                  Pelanggan senang, Anda bisa mendorong upselling topping.
                </VListItemTitle>
              </VListItem>
              <VListItem prepend-icon="ri-star-line" class="px-0">
                <VListItemTitle class="text-body-2 text-wrap">
                  <strong>Nama opsi yang jelas mengurangi salah pilih kasir.</strong>
                  Gunakan nama yang spesifik seperti "Less Sugar (½ gula)" daripada cuma "Less".
                  Kasir akan lebih yakin dalam memilihkan untuk pelanggan.
                </VListItemTitle>
              </VListItem>
            </VList>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>

    <!-- ── FAQ ────────────────────────────────────────────────────────── -->
    <VRow class="mt-4">
      <VCol cols="12">
        <h5 class="text-h5 font-weight-bold mb-3">
          ❓ Pertanyaan yang Sering Ditanyakan
        </h5>
        <VExpansionPanels variant="accordion">
          <VExpansionPanel v-for="(item, i) in faq" :key="i">
            <VExpansionPanelTitle class="text-body-2 font-weight-medium">
              {{ item.q }}
            </VExpansionPanelTitle>
            <VExpansionPanelText>
              <p class="text-body-2 mb-0">
                {{ item.a }}
              </p>
            </VExpansionPanelText>
          </VExpansionPanel>
        </VExpansionPanels>
      </VCol>
    </VRow>

    <!-- ── LINK TERKAIT ───────────────────────────────────────────────── -->
    <VRow class="mt-6">
      <VCol cols="12">
        <h5 class="text-h5 font-weight-bold mb-3">
          🔗 Halaman Terkait
        </h5>
        <VRow>
          <VCol
            v-for="link in [
              { title: 'Produk', sub: 'Hubungkan modifier group ke produk', icon: 'ri-cup-line', color: 'info', to: '/userguide/produk-inventory/produk' },
              { title: 'Kategori Produk', sub: 'Kelola kategori produk', icon: 'ri-price-tag-3-line', color: 'primary', to: '/userguide/produk-inventory/kategori' },
              { title: 'POS Kasir', sub: 'Lihat cara modifier muncul di kasir', icon: 'ri-shopping-cart-line', color: 'success', to: '/userguide/operasional/pos-kasir' },
            ]"
            :key="link.title"
            cols="12"
            sm="6"
            md="4"
          >
            <RouterLink :to="link.to" class="text-decoration-none">
              <VCard variant="outlined" hover class="h-100">
                <VCardText class="d-flex align-center gap-3 py-3">
                  <VAvatar :color="link.color" variant="tonal" size="40" rounded>
                    <VIcon :icon="link.icon" size="22" />
                  </VAvatar>
                  <div>
                    <p class="text-body-2 font-weight-bold mb-0">
                      {{ link.title }}
                    </p>
                    <p class="text-caption text-medium-emphasis mb-0">
                      {{ link.sub }}
                    </p>
                  </div>
                </VCardText>
              </VCard>
            </RouterLink>
          </VCol>
        </VRow>
      </VCol>
    </VRow>
  </div>
</template>
